import React from 'react';
import { Link } from 'react-router-dom';

/** GOVOPS-1125 — Outreach links (dashboard, admin, sidebar). */
const PilotDemoNavLinks = ({ className = 'rhs-quick-nav-item' }) => (
  <>
    <Link to="/demo" className={className}>
      Pilot demo
    </Link>
    <a
      href="/pilot-deck.html"
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      Presenter deck
    </a>
  </>
);

export default PilotDemoNavLinks;
